import React, { useEffect, useState } from "react";
import Section1 from "../../components/Allcontent/Section1";
import editorialservices from "../../json/Allservices/Editorialoffice.json";
import copyediting from "../../json/Allservices/Copyediting.json";
import projectmanagement from "../../json/Allservices/Projectmanagement.json";
import journalproduction from "../../json/Allservices/Journalproduction.json";
import bookproduction from "../../json/Allservices/Bookproduction.json";
import graphics from "../../json/Allservices/Graphics.json";
import peerreview from "../../json/Allservices/Peerreview.json";
import Ebooks from "../../json/Allservices/Ebooks.json";
import Accessibility from "../../json/Allservices/Accessibility.json";
import contentdigitization from "../../json/Allservices/Contentdigitization.json";
import contenttransformation from "../../json/Allservices/Contenttransformation.json";
import contentConversion from "../../json/Allservices/Contentconversion.json";
import healthops from "../../json/Allservices/Healthops.json";
import { useLocation, useParams } from "react-router-dom";
import Section2 from "../../components/Alldigital/digiSection2";
import Section3 from "../../components/Allcontent/Section3";
import Section4 from "../../components/Allcontent/Section4";
import Section5 from "../../components/Allcontent/Section5";
import Sections2 from "../../components/Allcontent/Section2";

const AllContent = () => {
  const { services } = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const [data, setData] = useState("");

  useEffect(() => {
    setdata(services);
  }, [services]);

  const setdata = (services) => {
    switch (services) {
      case "editorialoffice":
        return setData(editorialservices);
      case "copyediting":
        return setData(copyediting);
      case "projectmanagement":
        return setData(projectmanagement);
      case "journalproduction":
        return setData(journalproduction);
      case "bookproduction":
        return setData(bookproduction);
      case "graphics":
        return setData(graphics);
      case "peerreview":
        return setData(peerreview);
      case "ebooks":
        return setData(Ebooks);
      case "accessibility":
        return setData(Accessibility);
      case "contentdigitization":
        return setData(contentdigitization);
      case "contenttransformation":
        return setData(contenttransformation);
      case "contentconversion":
        return setData(contentConversion);
      case "healthops":
        return setData(healthops);
      default:
        return null;
    }
  };

  return (
    <div className="w-full flex flex-col items-center ruler">
      {data ? (
        <>
          <Section1 data={data} />
          {!data.desc1  && firstPath=="digital"? <Section2 data={data}  /> :!data.desc1 ?<Sections2 data={data} path={services} />:""}
          {data.section2 ? <Section4 data={data.section2} /> : ""}
          {data.why ? <Section3 data={data} /> : ""}
          {data.desc1 ? <Section5 data={data} /> : ""}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default AllContent;
